import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  fetchUsers,
  selectLoading,
  selectUsers
} from '../../features/users/usersSlice'

import { Button, Card, Form, Input, Space, Table, message } from 'antd'
import { Layout } from '../../components/Layout'
import { Spinner } from '../../components/Spinner'

import { api } from '../../api';
import { IS_ADMIN } from '../../constants';

const tailItemLayout = {
  wrapperCol: {
    xs: {
      span: 24
    },
    md: {
      offset: 6,
      span: 12
    }
  }
}

const COLUMNS = [
  {
    dataIndex: 'email',
    title: 'Email',
    width: 120
  },
  {
    dataIndex: 'first_name',
    title: 'First Name',
    width: 150
  },
  {
    dataIndex: 'last_name',
    title: 'Last Name',
    width: 150
  },
  {
    dataIndex: 'iam_username',
    title: 'IAM username',
    width: 150
  },
  {
    dataIndex: 's3_filepath',
    title: 'S3 FolderPath',
    width: 150
  }
]

export const ConfirmEmail = () => {
    const dispatch = useDispatch();

    const [ ConfirmEmail ] = Form.useForm();
    const [ passwordUpdating, setPasswordUpdating ] = useState(false);
    const windowUrl = window.location.search;
    const params = new URLSearchParams(windowUrl);
    const token = params.get('token')

    const profileLoading = useSelector(selectLoading);
  
    if (profileLoading) return (
      <Spinner />
    );

    const onConfirmEmail = async () => {
      try {
        setPasswordUpdating(true);
        await api('/api/confirm_email', {  
            token,
            
        });
        message.success("Email Confirmed !");
      } catch (e) {
        message.error(e.message);
      } finally {
        setPasswordUpdating(false);
      }
    };
  
    

  return (
    <Layout.Content>
      <Space direction="vertical" size={50} style={{ display: 'flex' }}>
      <Card type="inner" title="Confirm Email">
        <Form
          size="large"
          layout="horizontal"
          onFinish={ onConfirmEmail }
          form={ ConfirmEmail }
         >
          <Form.Item {...tailItemLayout} style={{ textAlign: 'center'}}>
            <Button type="primary" htmlType="submit" loading={ passwordUpdating }>Confirm Email</Button>
          </Form.Item>
        </Form>
      </Card>
      </Space>  
    </Layout.Content>
  )
}
